/**
 * 保留前后四位 中间每4个*会有一个空格  6212 **** **** *** 0222
 * @param {value} 传入数据
 */
const bankCard = (value) => {
    if (value && value.length > 8) {
        return `${value.substring(0, 4)} ${"*".repeat(value.length - 8).replace(/(.{4})/g, `$1 `)}${value.length % 4 ? " " : ""}${value.slice(-4)}`;
    }
    return value;
}

/**
 * 只显示后四位 *********** 0222
 * @param {value} 传入数据
 */
const onlyFourBank = (value) => {
    if (value && value.length > 8) {
        return `${"*".repeat(value.length - 8)}${value.length % 4 ? " " : ""}${value.slice(-4)}`;
    }
    return value;
}

/**
 * 一串数字每四位数字用空格隔开,8222 8000 1000 11 
 * @param {num} 传入数据
 */
const fourNums = (num) => {
    return num.replace(/(.{4})/g, "$1 ")
}


module.exports = {
    bankCard,
    onlyFourBank,
    fourNums
}